import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { SelectorRowVariants, } from '../../types/selectorRow';
import { SelectorRowCheckbox } from '../selectorRowCheckbox/selectorRowCheckbox';
import { SelectorRowToogle } from '../selectorRowToggle/selectorRowToggle';
const REGULAR = 'REGULAR';
export const ExtraContent = React.forwardRef(({ variant, selected, disabled = false, toggleUncontrolled = true, onToggleChange, onCheckboxChange, toggleConfig, checkboxConfig, }, ref) => {
    if (variant !== SelectorRowVariants.WITH_TOGGLE &&
        variant !== SelectorRowVariants.WITH_CHECKBOX) {
        return null;
    }
    return variant === SelectorRowVariants.WITH_TOGGLE ? (_jsx(SelectorRowToogle, { disabled: disabled, selected: selected, toggleConfig: toggleConfig, toggleUncontrolled: toggleUncontrolled, variant: REGULAR, onToggleChange: onToggleChange })) : (_jsx(SelectorRowCheckbox, { checkboxConfig: checkboxConfig, checked: selected, disabled: disabled, variant: REGULAR, onCheckboxChange: onCheckboxChange }));
});
ExtraContent.displayName = 'ExtraContent';
//# sourceMappingURL=extraContent.js.map